import {
  SET_CLASS_COUNT,
  SET_CLASSES,
  SET_CLASS,
  SET_CLASS_SEARCH,
  SET_TRAINER_ATTRIBUTES
} from '../../actions/types/types';

const initState = {
  classes: [],
  classData:{},
  classCount: 0,
  trainerAttributes:[],
  home_search:""
};

const ClassReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_CLASSES:
      return {
        ...state,
        classes: action.payload.data,
        count: action.payload.count
      };
    case SET_CLASS:
      return {
        ...state,
        classData: action.payload.data,
      };
    case SET_CLASS_COUNT:
      return {
        ...state,
        classCount: action.payload.data,
      };
    case SET_CLASS_SEARCH:
      return {
        ...state,
        home_search: action.payload.data,
      };
      case SET_TRAINER_ATTRIBUTES:
        return { ...state, trainerAttributes: action.payload.data };      

    default:
      return { ...state };
  }
};

export default ClassReducer;
